import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { DefaultColorPickerValues } from '@coin/shared/cms/util';
import { HtmlEditorComponent } from '../../shared/html-editor/html-editor.component';

interface Footnote {
  type: string;
  content: string;
  textColor: string;
  backgroundColor: string;
}

@Component({
  selector: 'coin-a-email-footnotes',
  templateUrl: './email-footnotes.component.html',
  styleUrls: ['./email-footnotes.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [HtmlEditorComponent]
})
export class EmailFootnotesComponent implements OnInit {
  @Input() item: Footnote;
  @Input() showAdditionalEditOptions = true;

  ngOnInit(): void {
    this.item ??= {} as Footnote;
    this.setDefaultColors();
  }

  public setDefaultColors(): void {
    this.item.textColor = this.item.textColor || DefaultColorPickerValues.textColor;
    this.item.backgroundColor = this.item.backgroundColor || DefaultColorPickerValues.backgroundColor;
  }
}
